import axios from "axios";
import store from "@/store";
import { setupResponseInterceptor } from './responseInterceptor';

const baseURL =
  process.env.VUE_APP_METRICS_RESILIENCE_URL ||
  (process.env.VUE_APP_METRICS_URL
    ? process.env.VUE_APP_METRICS_URL.replace('/api/v1', '/resilience/v1')
    : undefined);

const metricsResilienceClient = axios.create({
  baseURL,
  withCredentials: true,
});

metricsResilienceClient.interceptors.request.use((config) => {
  config.headers.lang = store.getters["getLang"];
  return config;
});

setupResponseInterceptor(metricsResilienceClient);

export default metricsResilienceClient;
